export type SendingOwner = { workspaceId: string } | { organizationId: string };

export function getSendingOwnerQueryKey(owner: SendingOwner) {
    return "workspaceId" in owner
        ? (["workspace", owner.workspaceId] as const)
        : (["organization", owner.organizationId] as const);
}

export function requireOwner(owner: SendingOwner | null): SendingOwner {
    if (!owner) {
        throw new Error("No active sending owner");
    }
    return owner;
}
